import { createUseStyles } from '@glu/theming';

const styles = {
  root: {
    display: 'flex',
  },
};

export default createUseStyles(styles);
